export enum ManagedListType {
  MOORING_STYLE = 'mooring-style',
  COASTAL_AREA = 'coastal-area',
  POI_CATEGORY = 'poi-category',
  POI_SUBTYPE = 'poi-subtype',
  SERVICE_CATEGORY = 'service-category',
  SERVICE_SUB_CATEGORY = 'service-sub-category',
  HARBOR_FACILITY = 'harbor-facility',
  HARBOR_CATEGORY = 'harbor-category',
  NAVIGATIONAL_AID = 'navigational-aid',
  FAIRWAY_CATEGORY = 'fairway-category',
  WATERWAY_SIGN = 'waterway-sign',
}

export enum ListValueStatus {
  DRAFT = 'draft',
  APPROVED = 'approved',
  DEPRECATED = 'deprecated',
}

export enum WaterLevelProvider {
  FMI = 'fmi',
  SYKE = 'syke',
}

export interface PublicListValue {
  id: string | number;
  key: string;
  name: string;
  label: string;
  description: string | null;
  status: ListValueStatus;
  category_id?: string | null;
  category?: string | null;
  icon_id?: number | null;
  subcategories?: PublicListValue[];
  water_level_provider?: WaterLevelProvider | null;
}

export interface AdminListValue {
  id: string | number;
  type: ManagedListType;
  key: string;
  description: string | null;
  label_fi: string | null;
  label_sv: string | null;
  label_en: string | null;
  label_de: string | null;
  status: ListValueStatus;
  notes: string | null;
  linked_jira_issue: string | null;
  display_order?: number | null;
  category_id?: string | null;
  category?: string | null;
  icon_id?: number | null;
  subtypes?: AdminListValue[];
  subcategories?: AdminListValue[];
  water_level_provider?: WaterLevelProvider | null;
}

export interface ListValueQueryParams {
  type: ManagedListType;
  status?: ListValueStatus;
  category_id?: string;
  category?: string;
}

export interface UpsertListValuePayload {
  key: string;
  description?: string;
  label_fi: string;
  label_sv: string;
  label_en: string;
  label_de: string;
  status?: ListValueStatus;
  notes?: string;
  linked_jira_issue?: string;
  category_id?: string;
  category?: string;
  icon_id?: number;
  display_order?: number | null;
  water_level_provider?: WaterLevelProvider | null;
}
